import type { Maybe } from '@tectonics/utils/types';
import { stripNonMatching } from '@tectonics/utils/formatting';

export function normalizeCustomerDocument(documentValue: Maybe<string>): string {
  return documentValue ? stripNonMatching(documentValue, 'numeric') : '';
}
